import * as React from 'react';
import '../css/hero-image.sass';

interface HeroImageProps {
  bgImg: string;
  name: string;
  tagLine: string;
  children?: any;
}

export default function HeroImage(props: HeroImageProps) {
  return (
    <div className="hero-image" style={{ background: `url(${props.bgImg})` }}>
      <div className="pkg-info">
        <h1>{props.name}</h1>
        <p>{props.tagLine}</p>
      </div>
      {props.children}
    </div>
  );
}
